// This is a partial duplication of config/taxonomy.yml. Eventually this should get auto-built
// server side.
const categoryConfig = [
  {
    uuid: 'e71b6e43-7217-4746-b4e3-64bf708a2664',
    slug: 'software',
    name: 'Software',
  },
  {
    uuid: '0d1dd31d-50d4-45a2-a640-8e59e6262f26',
    slug: 'digital-audio-workstations',
    name: 'DAWs',
    parentUuid: 'e71b6e43-7217-4746-b4e3-64bf708a2664',
  },
  {
    uuid: 'bc2129f6-85c3-4908-af96-d74828a1e783',
    slug: 'instruments',
    name: 'Instruments',
    parentUuid: 'e71b6e43-7217-4746-b4e3-64bf708a2664',
  },
  {
    uuid: 'c4b5fba6-6526-489c-994e-462ba5be75dd',
    slug: 'effects',
    name: 'Effects',
    parentUuid: 'e71b6e43-7217-4746-b4e3-64bf708a2664',
  },
  {
    uuid: '88c22106-091a-45b6-a0b2-32e8a33b92ff',
    slug: 'utilities',
    name: 'Utilities',
    parentUuid: 'e71b6e43-7217-4746-b4e3-64bf708a2664',
  },
  {
    uuid: 'ba6ed5ba-a92b-4fb7-b522-6314a221a21c',
    slug: 'presets',
    name: 'Presets',
    parentUuid: 'e71b6e43-7217-4746-b4e3-64bf708a2664',
  },
  {
    uuid: 'ea74dc25-00a0-4a0c-a12b-24e107aaa640',
    slug: 'learning',
    name: 'Learning',
    parentUuid: 'e71b6e43-7217-4746-b4e3-64bf708a2664',
  },
  {
    uuid: 'e6f8d815-68b8-405c-a96e-f633b56651f0',
    slug: 'mobile',
    name: 'Mobile',
    parentUuid: 'e71b6e43-7217-4746-b4e3-64bf708a2664',
  },
  {
    uuid: '1287ab0e-3696-408a-8c10-dbf4bf9a2fcc',
    slug: 'samples-and-loops',
    name: 'Samples and Loops',
    parentUuid: 'e71b6e43-7217-4746-b4e3-64bf708a2664',
  },
];

class Category {
  static findByUuid(uuid) {
    const attrs = categoryConfig.find(attr => attr.uuid === uuid);
    if (attrs) { return new Category(attrs); }
    return null;
  }

  static findBySlug(slug) {
    const attrs = categoryConfig.find(thisAttrs => thisAttrs.slug === slug);
    if (attrs) { return new Category(attrs); }
    return null;
  }

  static findByParentUuid(uuid) {
    const attrsList = categoryConfig.filter(attrs => attrs.parentUuid === uuid);

    return attrsList.map(attrs => new Category(attrs));
  }

  constructor(config) {
    this.uuid = config.uuid;
    this.slug = config.slug;
    this.name = config.name;
    this.parentUuid = config.parentUuid;
  }

  get parent() {
    if (this.parentUuid) {
      return Category.findByUuid(this.parentUuid);
    }

    return null;
  }

  get children() {
    return Category.findByParentUuid(this.parentUuid);
  }
}

export default Category;



// WEBPACK FOOTER //
// ./javascripts/components/taxonomy/category.js